import { render } from "./np-router-collapsible.vue?vue&type=template&id=52d3744f&scoped=true"
import script from "./np-router-collapsible.vue?vue&type=script&lang=js"
export * from "./np-router-collapsible.vue?vue&type=script&lang=js"

import "./np-router-collapsible.vue?vue&type=style&index=0&id=52d3744f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52d3744f"]])

export default __exports__